<script>
   /*************************************************************/
   /* AppPlots component for new tab                          */
   /* -----------------------------------                       */
   /* defines plot components, controls and parameters          */
   /*************************************************************/

   import { untrack } from 'svelte';
   import { getDefaults } from 'svelte-controls-basic';
   import { Container, Button } from 'svelte-controls-basic';

   // global plot router
   import PlotsRouter from '@mdatools-apps/shared/plots/PlotsRouter.svelte';

   // import plot components
   import PlotAcceptance from '../shared/PlotAcceptance.svelte';
   import PlotDataset from '../shared/PlotDataset.svelte';

   // import plot controls components
   import { LINE_COLORS } from '@mdatools-apps/shared/plots/Defaults.js';
   import { getPlotAcceptanceControls, getPlotExtremesControls } from '@mdatools-apps/shared/plots/Controls.svelte.js';

   let {
      nimca,
      newres,
      newsetp,
      markOutlier,
   } = $props();


   // the data and the results this component was mounted with. 'untrack' marks the capture as
   // deliberate: AppContainer wraps this component in a key block, so a new set of results arrives
   // as a new component and never as new props for this one
   const data = untrack(() => ({'new': newsetp}));
   const res = untrack(() => ({'new': newres}));


   // JSON with plot components (scope is needed for providing correct properties)
   const plots = $derived({
      acceptance: {label: 'Acceptance', scope: 'objects', component: PlotAcceptance, buttons: buttons},
      dataset: {label: 'Datasets', scope: 'objects', component: PlotDataset, buttons: buttons},
   })

   // JSON with plots controls (as Widget properties). a plain object: nothing here sets a
   // 'hidden' flag or touches a descriptor after it is made, so there is nothing for $state
   // to track - only 'params' below changes
   const controls = untrack(() => ({
      acceptance: getPlotAcceptanceControls(res),
      dataset: getPlotExtremesControls(['new']),
   }))

   // JSON with currently selected plots parameters
   let params = $state({
      acceptance: getDefaults(controls.acceptance),
      dataset: getDefaults(controls.dataset),
   });

   $effect(() => {
      params.acceptance['colorByObj'] = {
         values: newres.outcomes.decs,
         classColmap: {in: LINE_COLORS.new, out: LINE_COLORS.new},
         labels: ["in", "out"],
         filled: newres.outcomes.decs.map(v => v === 'in'),
         showBar: false
      }
   })

   // combine main elements to be shared with all plots together
   const props = $derived({ res, model: nimca, data});

</script>

{#snippet buttons(sel)}
   <Container label="Selected">
      <Button onclick={() => markOutlier(sel)} text="remove" class="destructive" />
   </Container>
{/snippet}


<PlotsRouter {plots} {controls} {props} bind:params={params} />